import { useEffect } from "react";
import Lenis from "lenis";
import { Navigate, BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import ShopPage from "@/pages/ShopPage";
import CartPage from "@/pages/CartPage";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import OldUrlRedirect from "@/components/OldUrlRedirect";
import Landing from "@/pages/Landing";
import ProductsPage from "@/pages/ProductsPage";
import CategoryPage from "@/pages/CategoryPage";
import DownloadPage from "@/pages/DownloadPage";
import SoftwarePage from "@/pages/SoftwarePage";
import ManualsPage from "@/pages/ManualsPage";
import FlipbookPage from "@/pages/FlipbookPage";
import ImpressumPage from "@/pages/ImpressumPage";
import SatZfPage from "@/pages/SatZfPage";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        window.__lenis = lenis;
        let raf = requestAnimationFrame(function loop(t) {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        });
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <div id="top" className="min-h-screen bg-slate-50 text-slate-900 antialiased">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <OldUrlRedirect />
                    <Navbar />
                    <CartProvider>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/produkte" element={<ProductsPage />} />
                        <Route path="/haendler/shop" element={<ShopPage />} />
                        <Route path="/haendler/warenkorb" element={<CartPage />} />
                        <Route path="/produkte/:slug" element={<CategoryPage />} />
                        <Route path="/produkte/sat-zf-verteilsysteme" element={<SatZfPage />} />
                        <Route path="/produkte/jrs-system" element={<Navigate to="/produkte/sat-zf-verteilsysteme#jrs" replace />} />
                        <Route path="/produkte/jultec" element={<Navigate to="/produkte/sat-zf-verteilsysteme#jultec" replace />} />
                        <Route path="/produkte/jultec-glasfaser" element={<Navigate to="/produkte/sat-zf-verteilsysteme#glasfaser" replace />} />
                        <Route path="/produkte/jultec-multischalter" element={<Navigate to="/produkte/sat-zf-verteilsysteme#multischalter" replace />} />
                        <Route path="/produkte/kathrein" element={<Navigate to="/produkte/sat-zf-verteilsysteme#kathrein" replace />} />
                        <Route path="/downloads" element={<DownloadPage />} />
                        <Route path="/downloads/software" element={<SoftwarePage />} />
                        <Route path="/downloads/bedienungsanleitungen" element={<ManualsPage />} />
                        <Route path="/pageflip" element={<FlipbookPage />} />
                        <Route path="/pageflip-preise" element={<FlipbookPage preise />} />
                        <Route path="/impressum" element={<ImpressumPage />} />
                    </Routes>
                    </CartProvider>
                    <Footer />
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
